



































import Vue, { PropType } from "vue";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";
import VariableInput from "@/components/util/VariableInput.vue";
import { mailCodeLengthLimit, mailCodeRegExp, mailCodeConstraintErrorMessage } from "./constraint";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import { createMailAuthCode } from "@/api/UserProfile";
import { validateAuthCodeMail } from "@/api/AuthCode";
import { updateAuthCodeFlag } from "@/jwt";

export default Vue.extend({
  name: "MailAuthentication",
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    "accountData.code"(code: string) {
      this.inputs["code"].error =
        code.length <= mailCodeLengthLimit && mailCodeRegExp.test(code) ? "" : mailCodeConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        code: "",
      },
      inputs: {
        code: {
          name: "認証コード",
          type: "text",
          placeholder: "認証コード",
          constraint: mailCodeConstraintErrorMessage,
          error: "",
        },
      },
      generalError: "",
      authPhonNumber: "",
      loginSuccess: false,
    };
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.loginSuccess) {
      document.getElementById("header")!.style.background = "#fff url(/images/common/header_bg.svg)";
    }
    next();
  },
  created() {
    document.getElementById("header")!.style.background = "#fff url()";
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.code.length <= mailCodeLengthLimit && mailCodeRegExp.test(this.accountData.code));
    },
    getUserId(): string {
      return this.$store.getters.userProfile.userId;
    },
    getMailAddress(): string {
      return this.$route.params.mailAddress;
    },
  },
  methods: {
    async onClickSubmit() {
      try {
        // 認証コードの検証
        let result = await validateAuthCodeMail({
          mailAddress: this.getMailAddress,
          authCode: this.accountData.code,
        });

        // 検証の結果がtrueであれば、ローカルストレージの認証フラグを更新してトップ画面に遷移
        if (result.isValidated) {
          this.loginSuccess = true;
          updateAuthCodeFlag("true");
          this.onPushPath("/");
        } else {
          this.generalError = result.message;
          return;
        }
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.generalError = resError.message;
        }
      }
    },
    /**  認証コード再送 */
    async resendAuthMail() {
      await createMailAuthCode({
        mailAddress: this.getMailAddress,
      });
      this.accountData.code = "";
      this.generalError = "";
      this.$emit("toast", "認証コードを再送信しました。");
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit("pushPath", path);
    },
  },
});
